<template>
  <div class="brand-story-editor">
    <div class="row">
      <!-- ... (keep existing structure, but update image input column) -->
      <div class="col-md-6 mb-3">
        <label>圖片 (Image)</label>
        <div v-if="localData.image" class="mb-2 position-relative">
          <img
            :src="localData.image"
            class="img-fluid rounded border"
            style="max-height: 200px; object-fit: cover"
          />
          <button
            class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 p-1"
            @click="localData.image = ''"
            title="Remove"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Cropper Trigger -->
        <input
          type="file"
          ref="fileInput"
          class="d-none"
          accept="image/*,.heic,.heif"
          @change="onFileSelected"
        />
        <button
          class="btn btn-outline-primary btn-sm mb-2"
          @click="$refs.fileInput.click()"
        >
          <i class="fas fa-upload me-1"></i> 上傳並裁剪
        </button>

        <input
          type="text"
          class="form-control text-xs"
          v-model="localData.image"
          placeholder="Or enter URL directly"
          disabled
        />
      </div>

      <!-- ... (keep other cols) ... -->
      <div class="col-md-6">
        <div class="form-group mb-3">
          <label>副標題 (Subtitle)</label>
          <input
            type="text"
            class="form-control"
            v-model="localData.subtitle"
            placeholder="e.g. OUR PHILOSOPHY"
          />
        </div>
        <div class="form-group mb-3">
          <label>主標題 (Title)</label>
          <input
            type="text"
            class="form-control"
            v-model="localData.title"
            placeholder="e.g. Mastery in Motion"
          />
        </div>
      </div>

      <div class="col-md-12 mb-3">
        <label>內文 (Content)</label>
        <rich-text-editor v-model="localData.content" />
      </div>

      <div class="col-md-6 mb-3">
        <label>按鈕文字 (CTA Text)</label>
        <input type="text" class="form-control" v-model="localData.cta_text" />
      </div>
      <div class="col-md-6 mb-3">
        <label>按鈕連結 (CTA Link)</label>
        <input type="text" class="form-control" v-model="localData.cta_link" />
      </div>
    </div>

    <!-- Cropper Modal -->
    <ImageCropperModal
      :show="showCropper"
      :imageSrc="tempImageSrc"
      @close="showCropper = false"
      @save="handleCrop"
    />
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";
import ImageCropperModal from "../../components/ImageCropperModal.vue";
import RichTextEditor from "@/components/RichTextEditor.vue";

export default {
  name: "BrandStoryEditor",
  components: {
    ImageCropperModal,
    RichTextEditor,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localData: { ...this.modelValue },
      uploading: false,
      showCropper: false,
      tempImageSrc: "",
    };
  },
  watch: {
    localData: {
      handler(val) {
        this.$emit("update:modelValue", val);
      },
      deep: true,
    },
    modelValue: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.localData)) {
          this.localData = { ...val };
        }
      },
      deep: true,
    },
  },
  methods: {
    onFileSelected(e) {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (event) => {
        this.tempImageSrc = event.target.result;
        this.showCropper = true;
        e.target.value = "";
      };
      reader.readAsDataURL(file);
    },
    async handleCrop(blob) {
      this.showCropper = false;
      if (!blob) return;

      const formData = new FormData();
      formData.append("file", blob, "brand_story.jpg");

      this.uploading = true;
      try {
        Swal.showLoading();
        const response = await request.post("/api/admin/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        Swal.close();
        if (response.data.success) {
          this.localData.image = response.data.url;
        } else {
          Swal.fire("Error", "Upload failed", "error");
        }
      } catch (e) {
        Swal.close();
        console.error(e);
        Swal.fire("Error", "Upload failed: " + e.message, "error");
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
